module.exports = __webpack_public_path__ + "img/ava-8.56a8bfc4.png";